import { physicianDashboardSlice } from './physicianDashboardSlice';

export const packSlice = physicianDashboardSlice.injectEndpoints({
    endpoints: builder => ({
        // Get all packs for a card owner
        getPacks: builder.query({
            query: (cardOwnerId) => `/cardOwners/${cardOwnerId}/packReviews`,
            providesTags: ['PackList']
        }),
        // Get summary of packs for a card owner (for completeModal)
        getPacksSummary: builder.query({
            query: (cardOwnerId) => `/cardOwners/${cardOwnerId}/packReviews/summary`,
        }),
        // Get details for a specific pack
        getPackDetails: builder.query({
            query: ({ cardOwnerId, packReviewId }) => `/cardOwners/${cardOwnerId}/packReviews/${packReviewId}`,
        }),
        // Get all item reviews for a specific pack
        getPackItemReviews: builder.query({
            query: ({ cardOwnerId, packReviewId }) => `/cardOwners/${cardOwnerId}/packReviews/${packReviewId}/packItemReviews`,
        }),
        // Review an item on the pack
        updatePackItemReview: builder.mutation({
            query: ({ cardOwnerId, packReviewId, packItemReviewId, reviewData }) => ({
                url: `/cardOwners/${cardOwnerId}/packReviews/${packReviewId}/packItemReviews/${packItemReviewId}`,
                method: 'PATCH',
                body: reviewData,
            }),
            async onQueryStarted({ cardOwnerId, packReviewId, packItemReviewId }, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled;
                    dispatch(
                        packSlice.util.updateQueryData('getPackItemReviews', { cardOwnerId, packReviewId }, (draft) => {
                            const itemReview = draft.find((i) => i.id === packItemReviewId);
                            if (itemReview) {
                                Object.assign(itemReview, data);
                            }
                        })
                    );
                } catch (error) {
                    console.error('Failed to update pack item review:', error);
                }
            },
        }),
        // Submit Pack Review
        submitPackReview: builder.mutation({
            query: ({ cardOwnerId, packReviewId, feedback, status }) => ({
                url: `/cardOwners/${cardOwnerId}/packReviews/${packReviewId}`,
                method: 'PATCH',
                body: { 
                    status: status,
                    feedback: feedback 
                },
            }),
            invalidatesTags: ['PackList'],
        }),
        logUserAction: builder.mutation({
            query: ({ action, data }) => ({
                url: '/userActions',
                method: 'POST',
                body: { action, data },
            }),
        }),
    }),
});

export const {
    useGetPacksQuery,
    useGetPacksSummaryQuery,
    useGetPackDetailsQuery,
    useGetPackItemReviewsQuery,
    useUpdatePackItemReviewMutation,
    useSubmitPackReviewMutation,
    useLogUserActionMutation,
} = packSlice;